export function processMarkdownTemplate(template: string, data: any) {
    if (!template) return ''

    return template.replace(/\{([^{}]+)\}/g, (match, p1) => {
        return data[p1]?.toString().trim() || match
    })
}
